import { useState, useEffect } from 'react';

const STORAGE_KEY = 'accountNotificationLastDismissed';
const NOTIFICATION_INTERVAL_DAYS = 7;

export function useAccountNotification() {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    checkNotificationStatus();
  }, []);

  function checkNotificationStatus() {
    const lastDismissed = localStorage.getItem(STORAGE_KEY);

    if (!lastDismissed) {
      const now = new Date();
      const firstShow = new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000);
      localStorage.setItem(STORAGE_KEY, firstShow.toISOString());
      setShowNotification(false);
      return;
    }

    const lastDismissedDate = new Date(lastDismissed);
    const now = new Date();
    const daysSinceLastDismissed = (now.getTime() - lastDismissedDate.getTime()) / (1000 * 60 * 60 * 24);

    if (daysSinceLastDismissed >= NOTIFICATION_INTERVAL_DAYS) {
      setShowNotification(true);
    }
  }

  function dismissNotification() {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setShowNotification(false);
  }

  return { showNotification, dismissNotification };
}
